import React from "react";
import { isDev } from "@/modules/commonMobile";
import { IGameTableType } from "@/types/GlobalTypes";
import SlBet from "../../SlBet";

import "./index.scss";

export default class M34 extends React.Component<IGameTableType> {
    render() {
        const {
            langdata,
            maximised,
            portrait,

			pcode,
			chipBase,
			mobile,
			bets,
			insertBet
        } = this.props;

		const dev = isDev();

        const lines = dev
		?
        // Dev
        // [bet type, bet group]
        [
            ["Odd", "n_odd"],
            ["Hi", "n_high"],
            ["7", "n7"],
            ["Lo", "n_low"],
            ["Even", "n_even"]
        ] :
		// Live
		[
            "odd",
            "Hi",
            "07",
            "Lo",
            "even",
        ];


        const labels = [
            langdata['txt_odd'],
            "Hi",
            "7",
            "Lo",
            langdata['txt_even'],
        ];

        const commonBetProps = {
			langStr: langdata.language_code,

			pcode,
			chipBase,
			mobile,
			bets,
            insertBet
		};

        return (
            <div className="sl-table m34">
                <div className="content">
                    {
                        lines.map((item, idx) => {
                            const styles = "sl-bet" + 
                                (maximised || portrait ? " sl-baccarat-bet-blue" : " sl-green-old") 
                                + (
									idx === 1
									? " baccarat-blue-text hilo"
									: idx === 3
									? " baccarat-red-text hilo"
									: ""
								);

							const betGroupObj = dev
							? // Dev
							{
								bet: item[0],
								group: item[1]
							}
							: // Live
							{
								bet: item,
								group: "e1"
							}

                            return (
                                <SlBet key={"m34_" + item}

                                    classes={styles}

									{... betGroupObj}

                                    // Live
                                    // bet={item}
                                    // group="e1"

                                    // Dev
                                    // bet={item[0]}
                                    // group={item[1]}

                                    winStatement={false}

                                    betLabel={labels[idx]}
                                    betType="5:1"

                                    noTooltip={true}

                                    {...commonBetProps}
                                />
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}